import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/vercel/path0/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "build/bundle.css",
    "revision": "3c32f760c53861c501dc1436078039dc"
  },
  {
    "url": "build/bundle.js",
    "revision": "84670004d871eb577fd2a446bb33448c"
  },
  {
    "url": "favicon-16x16.png",
    "revision": "9ebb50244e61db367f98bfa52d66f62d"
  },
  {
    "url": "favicon-32x32.png",
    "revision": "7ce2bf6eb2285f11c8d2a4bbc0fa3634"
  },
  {
    "url": "img/link_to_github.png",
    "revision": "62ac356b7ef9c897caa4e3f0cdf121d9"
  },
  {
    "url": "income-tax-calculator.png",
    "revision": "cd36ac221b0152c18b9e6aa6542f453b"
  },
  {
    "url": "index.html",
    "revision": "206b40c757270f2ca42bf0f91570f614"
  },
  {
    "url": "loadFont.js",
    "revision": "10c2fef2907b502b102d90c16af0921b"
  },
  {
    "url": "manifest.json",
    "revision": "dd30957b13211eacf1b348c5d5aadda2"
  },
  {
    "url": "registerWorker.js",
    "revision": "6a4062b220c80fce15d3871175431e45"
  }
], {});








